import { OffersTypes } from './types'
import { OfferSavePayload, OfferEditPayload } from './reducer'

export function addOffers(offers: OfferSavePayload[]) {
  return {
    type: OffersTypes.SAVE_OFFERS,
    payload: offers
  }
}

export function addOffer(offer: OfferSavePayload) {
  return {
    type: OffersTypes.SAVE_OFFER,
    payload: offer
  }
}

export function editOffer(offer: OfferEditPayload) {
  return {
    type: OffersTypes.EDIT_OFFER,
    payload: offer
  }
}

export function removeOffer(index: number) {
  return {
    type: OffersTypes.REMOVE_OFFER,
    payload: index
  }
}
